import React from 'react';
import WalletPage from './pages/WalletPage';
import Home from './pages/Home';
import Header from './components/Header';
import {Route, Routes} from 'react-router-dom';

function Wallet_page() {
  return (
    <>
      <Header />
      <WalletPage />
    </>
  )
}

function App() {
    return (
      <>
        {/* <Header /> */}
        <div className="pages">
          <Routes>
            <Route path="/wallet" element={<Wallet_page />} />
            <Route path="/" element={<Home />} />
            <Route path='*' element={<Header />} />
          </Routes>
        </div>
      </>
    );
}

export default App;
